import { render, staticRenderFns } from "./EmpresaCategorias.vue?vue&type=template&id=387d24cc&scoped=true&"
import script from "./EmpresaCategorias.vue?vue&type=script&lang=js&"
export * from "./EmpresaCategorias.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaCategorias.vue?vue&type=style&index=0&id=387d24cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d24cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
